export default __webpack_public_path__ + "static/media/apply_image_edits_in_bulk.63d2ed65.png";